/**
 * TanStack keys for everything the query builder fetches per workspace, each
 * level built from the one above. Kept free of imports so any module in the
 * builder can key its queries without a cycle.
 */
export const analyticsQueryKeys = {
  all: (workspaceId: number) => ['workspace', workspaceId, 'analytics-query'] as const,
  runs: (workspaceId: number) => [...analyticsQueryKeys.all(workspaceId), 'run'] as const,
  /** One spec's run, keyed by the spec itself, so the same JSON shares one run. */
  run: <Spec>(workspaceId: number, spec: Spec) => [...analyticsQueryKeys.runs(workspaceId), spec] as const,
  /** The views' members and relationships, static per deploy. */
  catalog: (workspaceId: number) => [...analyticsQueryKeys.all(workspaceId), 'catalog'] as const,
};
